import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import ChiefOfStaff from "./ChiefOfStaff";
import NotificationBell from "./NotificationBell";
import { useAuth } from "../lib/auth";

export default function AppLayout({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDF8F5]">
        <div className="flex items-center gap-2 font-heading text-slate-500">
          <span className="dot-blink w-2 h-2 rounded-full bg-slate-900" />
          <span className="dot-blink w-2 h-2 rounded-full bg-slate-900" style={{ animationDelay: "0.2s" }} />
          <span className="dot-blink w-2 h-2 rounded-full bg-slate-900" style={{ animationDelay: "0.4s" }} />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="flex bg-[#FDF8F5] min-h-screen">
      <Sidebar />
      <main className="flex-1 min-w-0 relative">
        <div className="absolute top-3 right-4 z-30">
          <NotificationBell />
        </div>
        {children}
      </main>
      <ChiefOfStaff />
    </div>
  );
}
